
import twemoji from 'twemoji';

export default function InitTwemoji() {
    twemoji.parse(document.body.querySelector('.page-container'),  { base: '/twemoji/' });
}